import { SenderModel } from "@cakemail-org/ui-components-v2"

export function getDomain(sender: SenderModel) {
    const atIndex = sender.email.indexOf("@")
    const domain = sender.email.substring(atIndex + 1)

    return domain
}